var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 12V10M8 8.66667V12M10.6667 12V7.33333M4.33333 7.66667L5.30973 6.52753C5.94365 5.78797 6.92247 5.44045 7.8808 5.61469C9.208 5.85601 10.5692 5.43081 11.5231 4.47695L11.6667 4.33333M14 6.66667V6.6C14 4.79083 14 3.88625 13.5793 3.22897C13.3714 2.90431 13.0957 2.62857 12.7711 2.42075C12.1137 2 11.2092 2 9.4 2H6.8C4.80014 2 3.80021 2 3.09924 2.50929C2.87285 2.67377 2.67377 2.87285 2.50929 3.09924C2 3.80021 2 4.80014 2 6.8V9.2C2 11.1999 2 12.1998 2.50929 12.9007C2.67377 13.1271 2.87285 13.3262 3.09924 13.4907C3.80021 14 4.80014 14 6.8 14H9.33333C11.2059 14 12.1423 14 12.8149 13.5506C13.106 13.356 13.356 13.106 13.5506 12.8149C14 12.1423 14 11.2059 14 9.33333",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataOutlined);
export default __webpack_public_path__ + "static/media/data_outlined.2ca3d1bd30e2b929b8aba74e20edc178.svg";
export { ForwardRef as ReactComponent };